module.exports = __webpack_public_path__ + "static/media/printer.0a922667.svg";